var React = require('react');

function Favorite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m15 26.6875-1.8125-1.65c-6.4375-5.8375-10.6875-9.6875-10.6875-14.4125 0-3.85 3.025-6.875 6.875-6.875 2.175 0 4.2625 1.0125 5.625 2.6125 1.3625-1.6 3.45-2.6125 5.625-2.6125 3.85 0 6.875 3.025 6.875 6.875 0 4.725-4.25 8.575-10.6875 14.425z","fill":"#fa104d"}));
}

Favorite.defaultProps = {"fill":"none","height":"30","viewBox":"0 0 30 30","width":"30"};

module.exports = Favorite;

Favorite.default = Favorite;
